import { HTTP_CLIENT } from "../utils/services";

const tokenSwapValidate = async () => {
  return await HTTP_CLIENT.get("/native-wallet/validate-swap");
};
export default tokenSwapValidate;
